import React from 'react';
import { openExtLink } from '../../utils/usefulFunctions';
import Button from '../../muiComponents/Button';
import useTranslate from '../../customHooks/useTranslate';

export default function AuthorizationOfPersonalDataCV({ history }) {
    const translate = useTranslate();

    function handleOnClick() {
        localStorage.setItem('jobConditionsAccepted', true);
        history.push('/jobs');
    }

    return (
        <div className='width100perc'>
            <div className='faq margin-auto margin-bottom-16 text-align-justify'>
                <p className='padding-bottom-16'>
                    {translate('authorization_title')}
                </p>
                <p className='padding-bottom-8'>
                    {translate('authorization_paragraph_2')}
                </p>
                <p className='padding-bottom-8'>
                    {translate('authorization_paragraph_3')}
                </p>
                <p className='padding-bottom-8'>
                    {translate('authorization_paragraph_4')}
                </p>
                <p className='padding-bottom-8'>
                    {translate('authorization_paragraph_5')}
                </p>
                <p className='padding-bottom-8'>
                    {translate('authorization_paragraph_6')}
                    <a
                        className='link-style'
                        href='https://www.aepd.es/es'
                        onClick={openExtLink}
                    >
                        www.aepd.es
                    </a>
                    .
                </p>
                <p className='padding-bottom-8'>
                    {translate('authorization_paragraph_7')}
                </p>
            </div>

            <div className='faq margin-auto margin-bottom-16 padding-bottom-16 flex-between'>
                <a
                    href='https://www.fastpayhotels.com/'
                    className='btn-outline-success'
                >
                    {translate('cancel')}
                </a>

                <Button
                    variant='contained'
                    type='button'
                    className='jobsMuggle-boton'
                    onClick={handleOnClick}
                >
                    {translate('accept')}
                </Button>
            </div>
        </div>
    );
}
